import {
  Injectable,
  ComponentFactoryResolver,
  ApplicationRef,
  Injector,
} from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable, throwError, Subject } from "rxjs";
import { catchError, tap, timeout } from "rxjs/operators";
import { EpPopupComponent } from "../../components/ep-popup/ep-popup.component";

@Injectable({
  providedIn: "root",
})
export class EpHttpService {
  private loadingSubject = new Subject<boolean>();
  loading$ = this.loadingSubject.asObservable();

  constructor(
    private http: HttpClient,
    private componentFactoryResolver: ComponentFactoryResolver,
    private appRef: ApplicationRef,
    private injector: Injector,
  ) {}

  request(method: string, uri: string, options?: any): Observable<any> {
    this.loadingSubject.next(true);
    return this.http.request(method, uri, options).pipe(
      timeout(30000),
      tap({
        next: () => {
          this.loadingSubject.next(false);
        },
      }),
      catchError((err) => {
        this.showPopup();
        this.loadingSubject.next(false);
        return throwError(err); // throw error to subscriptions
      }),
    );
  }

  // private handleError(err: HttpErrorResponse): void {
  //   this.errorService.push(err.message);
  // }

  private showPopup(): void {
    const componentFactory =
      this.componentFactoryResolver.resolveComponentFactory(EpPopupComponent);
    const componentRef = componentFactory.create(this.injector);
    this.appRef.attachView(componentRef.hostView);
    const domElem = (componentRef.hostView as any).rootNodes[0] as HTMLElement;
    document.body.appendChild(domElem);
    componentRef.instance.modalTitle = "Information Temporarily Unavailable";
    componentRef.instance.isOpen = true;
    componentRef.instance.isServiceError = true;
    componentRef.instance.closePopup.subscribe(() => {
      this.appRef.detachView(componentRef.hostView);
      componentRef.destroy();
    });
  }
}
